export default __webpack_public_path__ + "static/media/agile.d0891e57.svg";